import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  notificationData: {},
  isLoadingNotificationData: false,
  totalNotifications: 0,
};

export const getNotificationData: any = createAsyncThunk(
  "content/getNotificationData",
  async ({
    PageNumber,
    PageSize,
    searchText = null,
    Status,
    StartDate,
    EndDate,
    SortBy,
    SortDirection,
  }: any) => {
    const res = await axios.get(`/slpapp/Notification`, {
      params: {
        PageNumber,
        PageSize,
        searchText,
        SortBy,
        Status,
        StartDate,
        EndDate,
        SortDirection,
      },
    });
    const data = await res.data;

    return data;
  }
);

export const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications(state, action) {
      state.totalNotifications = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getNotificationData.pending, (state) => {
      state.isLoadingNotificationData = true;
    });
    builder.addCase(getNotificationData.fulfilled, (state, action) => {
      state.isLoadingNotificationData = false;
      state.notificationData = action.payload;
    });
    builder.addCase(getNotificationData.rejected, (state, action) => {
      state.isLoadingNotificationData = false;
      state.error = action.error.message;
    });
  },
});

export const { setNotifications } = notification.actions;
export default notification.reducer;
